import './styles/index.scss';

import { attachValidatorsToLunaForm } from './js/validation';
import aussiehomeloans from './js/aussiehomeloans';
import initializeAutocompletes from './js/autocomplete';
import fillCountryInput from './js/country-input-service.js';
import fillTemplateFileInfoInput from './js/templateFile-input-service';

// Make validation available for modal forms
// Modal forms: This will be called after an AJAX return
window.finder = Object.assign({}, window.finder, { attachValidatorsToLunaForm });

// Attach validation on stand-alone form
attachValidatorsToLunaForm('.js-luna-validate');
initializeAutocompletes();
fillCountryInput();
fillTemplateFileInfoInput();

/**
 * Make js functions available outside using
 * LeadForm module name (see rollup.config.js
 */
const LeadForm = {
  aussiehomeloans,
};
export default LeadForm;
